module.exports = __webpack_public_path__ + "img/gray-1.2ce9edba.svg";